/**
 * ReplyPreview - Preview da mensagem sendo respondida
 */

import React from 'react';
import type { ConversationMessage } from '@troia-v3/types';
import { Icon } from '@/shared/icons'
interface ReplyPreviewProps {
  message: ConversationMessage;
  onCancel: () => void;
}

const ReplyPreview: React.FC<ReplyPreviewProps> = ({ message, onCancel }) => {
  const getMessagePreview = () => {
    // Extract text content from message
    const textContent = message.content.find(
      (c) => c.type === 'text' && 'text' in c
    );

    if (textContent && 'text' in textContent) {
      return textContent.text.substring(0, 60) + (textContent.text.length > 60 ? '...' : '');
    }

    // Check for other content types
    const imageContent = message.content.find(c => c.type === 'image');
    if (imageContent) return '🖼️ Imagem';

    const videoContent = message.content.find(c => c.type === 'video');
    if (videoContent) return '🎥 Vídeo';

    const audioContent = message.content.find(c => c.type === 'audio');
    if (audioContent) return '🎵 Áudio';

    const documentContent = message.content.find(c => c.type === 'document');
    if (documentContent) return '📄 Documento';

    const locationContent = message.content.find(c => c.type === 'location');
    if (locationContent) return '📍 Localização';

    const contactContent = message.content.find(c => c.type === 'contact');
    if (contactContent) return '👤 Contato';

    return 'Mensagem';
  };

  return (
    <div
      className="border-t px-4 py-3"
      style={{
        borderColor: 'var(--theme-card-border)',
        backgroundColor: 'rgba(139, 92, 246, 0.1)'
      }}
    >
      <div className="flex items-start gap-3">
        {/* Reply Icon */}
        <div className="flex-shrink-0 mt-1">
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center"
            style={{ backgroundColor: 'rgba(139, 92, 246, 0.2)' }}
          >
            <Icon name="corner-up-left" className="w-4 h-4"
              style={{ color: 'var(--theme-sidebar-active)' }} />
          </div>
        </div>

        {/* Reply Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <p
              className="text-xs font-semibold"
              style={{ color: 'var(--theme-sidebar-active)' }}
            >
              Respondendo a {message.senderName || 'Mensagem'}
            </p>
          </div>

          {/* Border accent */}
          <div
            className="border-l-4 pl-3 py-1"
            style={{ borderColor: 'var(--theme-sidebar-active)' }}
          >
            <p
              className="text-sm truncate"
              style={{ color: 'var(--theme-card-text)' }}
            >
              {getMessagePreview()}
            </p>
          </div>
        </div>

        {/* Cancel Button */}
        <button
          onClick={onCancel}
          className="flex-shrink-0 p-1.5 rounded-lg transition-colors"
          style={{ color: 'var(--theme-muted-text)' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--theme-button-ghost-hover)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
          title="Cancelar resposta"
        >
          <Icon name="x" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default ReplyPreview;
